/**
 * User Profile Route - React Router v7
 *
 * Route: /user/profile
 * Description: User profile page with account info, notifications, and privacy settings
 */
import type {LoaderFunctionArgs} from 'react-router-dom'
import {useLoaderData} from 'react-router-dom'

import UserProfile from './index.js'

// Import styles
import './styles/index.scss'

/**
 * Loader for User Profile page
 * Fetches SEO data and page name
 */
export async function loader({context, request}: LoaderFunctionArgs) {
  const {domain, i18n} = context
  const {culture} = i18n
  const url = new URL(request.url)
  const path = url.pathname

  try {
    // Get page name
    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    // Get SEO data
    const [seoDataError, {head: helmet} = {}] = await domain.get('get_seo_data_use_case').execute({culture, pageName})

    if (seoDataError) {
      console.error('[UserProfile] SEO data error:', seoDataError)
    }

    return {
      helmet: helmet || {},
      pageName,
      seoDataError
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[UserProfile] Loader error:', error)
    return {
      helmet: {},
      pageName: 'user_profile',
      seoDataError: error
    }
  }
}

/**
 * Component wrapper
 * Uses existing UserProfile component
 */
export function Component() {
  const data = useLoaderData()
  return <UserProfile {...data} />
}

export default {loader, Component}
